<ion-card>
  <div class="left">
    <div
      class="image-border"
      [class.img]="isOnline && !!product?.imageThumbnail"
    >
      <app-product-card-image
        [imageThumbnail]="product?.imageThumbnail"
        [productNumber]="product?.productNumber"
        [isOnline]="isOnline"
        [clickable]="false"
      ></app-product-card-image>
    </div>
  </div>
  <div class="right">
    <div class="info">
      <app-product-card-information
        [brand]="product?.summary?.brand"
        [description]="product?.summary?.productDescTxtl"
        [productNumber]="product?.productNumber"
        [salesPackSize]="product?.summary?.salesPackSize"
        [showNote]="false"
        [notFound]="product?.notFound"
        [customerProductNumber]="product?.customerProductNumber"
        [showPowerReview]="false"
        [pricePerPortion]="product?.pricePerPortion"
        (productDescriptionClickEmitter)="onProductClick()"
        [clickable]="true"
        [isGuestUser]="false"
        [truncateAmount]="60"
        [isGuestUser]="false"
      >
      </app-product-card-information>
      <app-usf-product-tag-list
        [tagList]="product?.productTags"
        [infoIconEnabled]="false"
        [allTagsClickable]="true"
        [product]="transformProductToProductDetail()"
        [maxTags]="5"
      >
      </app-usf-product-tag-list>
    </div>
    <div class="ellipsis">
      <div class="price">
        <app-price-display
          [price]="product?.pricing"
          [displayCases]="true"
          [catchWeightFlag]="product?.summary?.catchWeightFlag"
          [priceUom]="product?.summary?.priceUom"
        ></app-price-display>
      </div>
      <app-product-card-ellipsis
        [notFound]="product?.notFound"
        (ellipsisClickEmitter)="ellipsisClick($event)"
        [isGuestUser]="false"
      >
      </app-product-card-ellipsis>
    </div>
  </div>
</ion-card>
